const RequiredIndicator = ({ className = '' }) => (
  <span className={`ml-1 text-error ${className}`} aria-hidden="true">
    *
  </span>
);

export default RequiredIndicator;
